import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const scrollbar: SxStyle = {
  maxHeight: '70vh',
  height: 'auto',
  overflowY: 'auto',
  padding: (p) => p.spacing(1.5),
};

export const popover: SxStyle = {
  width: (p) => p.spacing(46.5),
  mt: 1.5,
  overflow: 'visible',
};

export const box: SxStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: (p) => p.palette.common.white,
};

export const listIcon: SxStyle = {
  padding: (p) => p.spacing(0.5),
  borderRadius: (p) => p.spacing(0.5),
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.grey[300],
  color: (p) => p.palette.grey[500],
  cursor: 'pointer',
};

export const socialIcon: SxStyle = {
  '&:hover': {
    color: (p) => p.palette.primary[300],
  },
};

export const loading: SxStyle = {
  height: (theme) => theme.spacing(55),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const padding: SxStyle = {
  padding: (p) => p.spacing(0.5, 1.5, 1, 1.5),
};

export const title: SxStyle = {
  fontSize: (p) => p.typography.caption,
  color: (p) => p.palette.common.black,
  fontWeight: 400,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  maxWidth: (p) => p.spacing(35),
};

export const subHeader: SxStyle = {
  color: (p) => p.palette.grey[500],
  fontSize: (p) => p.typography.caption,
  fontWeight: 400,
};

export const domainLink: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  textDecoration: 'underline',
};

export const companyDescription: SxStyle = { p: 0 };
